// extracted by mini-css-extract-plugin
export default {"header":"notification_item-module___header___aa43184b","item":"notification_item-module___item___e2918a60"};